import type { SVGProps } from 'react';

interface AlertCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function AlertCircleIcon({ className, ...props }: AlertCircleIconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Ring tracks currentColor; accent stays chilli-blush by design so the
          glyph stays legible against a red ring regardless of the caller. */}
      <circle cx="9" cy="9" r="9" fill="currentColor" />
      <path
        d="M8.5 9.7501V5.25001C8.5 4.83579 8.83579 4.5 9.25 4.5C9.66421 4.5 10 4.83579 10 5.25001V9.7501C10 10.1643 9.66421 10.5001 9.25 10.5001C8.83579 10.5001 8.5 10.1643 8.5 9.7501Z"
        className="fill-chilli-blush"
      />
      <ellipse
        cx="9.255"
        cy="12.75"
        rx="0.755005"
        ry="0.750014"
        className="fill-chilli-blush"
      />
    </svg>
  );
}
